import { useEffect, useState } from "react";
import Anagrafica from "./Buttons/Anagrafica";
import Ordini from "./Buttons/Ordini";
import Interviste from "./Buttons/Interviste";
import CV from "./Buttons/CV";
import "./CardDetails.css";
import { useIsDirectResult } from "../../../../context/isDirectMatchingResult";

function CardDetails(props: any) {

    const { toggleView } = useIsDirectResult();

    const getAnagrafica = async() => {
        props.setAnagrafica(true);
        props.setOrdine(false);
        props.setIntervista(false);
        props.setCv(false);
    }

    const getOrdini = async() => {
        props.setAnagrafica(false);
        props.setOrdine(true);
        props.setIntervista(false);
        props.setCv(false);
    }

    const getInterviste= async() => {
        props.setAnagrafica(false);
        props.setOrdine(false);
        props.setIntervista(true);
        props.setCv(false);
    }

    const getCv = async() => {
        props.setAnagrafica(false);
        props.setOrdine(false);
        props.setIntervista(false);
        props.setCv(true);
    }

    const backDetails = () => {
        props.setUrlPDF("");
        props.setCodFisc("");
        props.setIsAI(false);
        props.setCvs("");
        props.setAnagrafiche([])
        props.setInterviste([])
        props.setOrdini([])
        props.setTimeOrdine(false)
        props.setTimeAnagrafica(false)
        props.setTimeIntervista(false)
        props.setTimeCvs(false)
        props.setDetails(false);
    }

    const getBack = () => {
        toggleView(true);
    }

    return (
    <div>
        <div id='CardDetailsSlot-4'>
            <div className='home-btn-slot-3'>
                <i className='bx bx-home bx-sm bx-border' id='home-btn-4' onClick={getBack}>
                    <span className='home-btn-text-2'>
                    Torna alla schermata Home
                    </span>
                </i>
            </div>
            <div className='home-btn-slot-4'>
                <i className='bx bx-sm bx-border' id='home-btn-2' onClick={backDetails}>
                    <span className='home-btn-text-2'>
                    {"◂ Torna ai Risultati"}
                    </span>
                </i>
            </div>
        </div>
        <div className="container-auto">
            <div className="center-div">
                <button className="cta-red-mat" onClick={getAnagrafica}>
                                {"Anagrafica"}
                </button>
                <button className="cta-red-mat" onClick={getOrdini}>
                                {"Storico Ordini"}
                </button>
                <button className="cta-red-mat" onClick={getInterviste}>
                                {"Storico Interviste"}
                </button>
                <button className="cta-red-mat" onClick={getCv}>
                                {"CV Candidato"}
                </button>
            </div>
            
            {(props.anagrafica)?<Anagrafica codFisc={props.codFisc} jobId={props.jobId} anagrafiche={props.anagrafiche} setAnagrafiche={props.setAnagrafiche} timeAnagrafica={props.timeAnagrafica} setTimeAnagrafica={props.setTimeAnagrafica}></Anagrafica>:
            <div>
                {(props.ordine)?<Ordini codFisc={props.codFisc} ordini={props.ordini} setOrdini={props.setOrdini} timeOrdine={props.timeOrdine} setTimeOrdine={props.setTimeOrdine}></Ordini>:
                <div>
                    {(props.intervista)?<Interviste codFisc={props.codFisc} interviste={props.interviste} setInterviste={props.setInterviste} timeIntervista={props.timeIntervista} setTimeIntervista={props.setTimeIntervista}></Interviste>:
                    <div>
                        {(props.cv && <CV cvs={props.cvs} setCvs={props.setCvs} codFisc={props.codFisc} urlPDF={props.urlPDF} setUrlPDF={props.setUrlPDF} userId={props.userId} isAI = {props.isAI} setIsAI = {props.setIsAI} timeCvs={props.timeCvs} setTimeCvs={props.setTimeCvs}></CV>)}
                    </div>
                }
                </div>
            }
            </div>
            }
        </div>
    </div>
    )
}

export default CardDetails;